import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import VueMask from "v-mask";
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(require('vue-shortkey'))
Vue.use(VueYouTubeEmbed)
// if you don't want install the component globally
Vue.use(VueYouTubeEmbed, { global: false })
// if you want to install the component globally with a different name
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" })
Vue.use(VueMask, {
  placeholders: {
    "#": null, // passing `null` removes default placeholder, so `#` is treated as character
    D: /\d/, // define new placeholder
    Я: /[\wа-яА-Я]/, // cyrillic letter as a placeholder
  },
});
// import plugin
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
// don't forget to import CSS styles
import "tiptap-vuetify/dist/main.css";
// Vuetify's CSS styles
import "vuetify/dist/vuetify.min.css";
Vue.config.productionTip = false;
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: "md",
});

/* Lodash injection */
import lodash from "lodash";
Object.defineProperty(Vue.prototype, "$lodash", {
  value: lodash,
});

/* Moment injection */
import moment from "moment";
Object.defineProperty(Vue.prototype, "$moment", {
  value: moment,
});
/* Vue Google Maps */
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAU4CVf8FLD6nXeKM_lSBL_nnY8DobX6Qs",
  },
});
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyAFbaLecDfQigrSKv58XgoZjbB83xjlUYQ",
});
let app;

import "./firebase.config";
import { auth } from "./firebase.config";

Vue.config.productionTip = false;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: "#app",
      created: function() {
        window.Vue = this;
      },
      router,
      vuetify,
      store,
      render: (h) => h(App),
    });
  }
});
